import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.onScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  handleScroll() {
    const root = document.documentElement
    if (window.scrollY > 20) {
      this.element.classList.add("h-16", "shadow-sm")
      this.element.classList.remove("h-20")
      this.element.style.borderBottomColor = "#F0EBE0"
      root.style.setProperty("--current-header-h", "64px")
    } else {
      this.element.classList.remove("h-16", "shadow-sm")
      this.element.classList.add("h-20")
      this.element.style.borderBottomColor = "transparent"
      root.style.setProperty("--current-header-h", "80px")
    }
  }
}
